export abstract class UiStateModelBase extends EventTarget
{
    abstract getValue(key: string): string|undefined;
    abstract setValue(key: string, value?: string|null): void;
    abstract toggleElementVisibility(key: UiElements): void;
}

let UiStateModel: UiStateModelBase|null = null;

function setUiStateModel(model: UiStateModelBase)
{
    UiStateModel = model;
}

export enum UiElements {
    PerformanceGraphs = "performance-graphs"
}

export enum UiStateModelParam {
    ApplicationMode = 'application-mode',
    FISubView = 'fi-sub-view',
    IMO = 'imo',
    IMODetails = 'imo-details',
    ListView = 'list-view',
    MainMenuComponent = 'main-menu-component',
    Search = 'q',
    SelectedMapLayer = 'selected-map-layer',
    SelectedWeatherControlComponent = 'selected-weather-control-component',
    PortRegion = 'region',
    PORT = 'port',
    VesselAlarmDetails = 'vessel-alarm-details',
    VesselAlarmId = 'vessel-alarm-id',
    SelecteMapView = "SelecteMapView"
}

export enum FiSubView {
    AlarmDetails = 'alarm-details',
    NearestPort = 'nearest-port',
    PortView = 'port-view',
    PortViewExpectedArrivals = 'port-view-expected-arrivals',
    PortsByRegionView = 'port-view-regions',
    VesselAlarms = 'vessel-alarms',
    VesselAlarmsLog = 'vessel-alarms-log',
    VesselDetails = 'vessel-details',
    ListView = 'list-view',
    VesselPastTrail = 'vessel-past-trail',
    VesselSchedule = 'vessel-schedule',
}

export { UiStateModel, setUiStateModel };
